// extracted by mini-css-extract-plugin
module.exports = {"container":"RelatedRPDocsSectionEditor_container_1BYxp","addNew":"RelatedRPDocsSectionEditor_addNew_2zn68","spinAround":"RelatedRPDocsSectionEditor_spinAround_2jEDJ"};